/* ========================================================================= */
/* Breakpoints */
/* ========================================================================= */

export const breakpoints = {
    main: '0px',
    sm: '640px',
    md: '1024px',
    lg: '1480px',
};

/**
 * @function isItBreakpoint
 * @param {string} fromBreakpoint (required)
 *     Possible values: 'main', 'sm', 'md',...
 * @param {string} toBreakpoint
 *     Possible values: 'main', 'sm', 'md',...
 * @return {boolean}
 *
 * Checks whether the current breakpoint matches the provided key.
 */
export const isItBreakpoint = (fromBreakpoint, toBreakpoint = null) => {
    [ fromBreakpoint, toBreakpoint ].forEach(breakpoint => {
        if (breakpoint && !breakpoints[breakpoint]) {
            console.warn(`The following breakpoint appears to be missing in the configuration: '${breakpoint}'.`);
        }
    });

    let mediaRule = `(min-width: ${breakpoints[fromBreakpoint]})`;

    if (toBreakpoint) {
        mediaRule = `${mediaRule} and (max-width: ${breakpoints[toBreakpoint]})`;
    }

    return window.matchMedia(mediaRule).matches;
};

/**
 * @function getBreakpoint
 * @param {array} _breakpoints (optional)
 *     Possible value: [ 'main', 'sm', 'md',... ]
 *     The list of breakpoints that should be checked (from low to high).
 * @return {string}
 *
 * Returns the current active breakpoint (based on the provided breakpoints,
 * or all of them if not specified).
 */
export const getBreakpoint = _breakpoints => {
    const clonedBreakpoints = [ ...(_breakpoints || Object.keys(breakpoints)) ];
    return clonedBreakpoints.reverse().find(breakpoint => isItBreakpoint(breakpoint));
};

/**
 * @function getBreakpointSize
 * @param {string} breakpoint (required)
 *     Possible values: 'main', 'sm', 'md',...
 * @return {number}
 *
 * Returns the breakpoint size (in pixels).
 */
export const getBreakpointSize = breakpoint => parseInt(breakpoints[breakpoint]);
